export default "__VITE_ASSET__DUKCmJx6__"